import { useNavigate } from 'react-router-dom';
import Logo from '../common/Logo';
import Button from '../common/Button';
import { getDefaultRoute } from '../../hooks/usePermission';
import { performLogout } from '../../utils/authHelpers';

/**
 * 이미 로그인한 사람이 첫 화면(회사 코드 입력)을 열었을 때.
 *
 * 왜(2026-10-06 fwee·numbuzin 문의): 전에는 말없이 본 화면으로 넘겼다. 그래서 «fwee 로 다시 들어가려고» 첫 화면을 연
 * 사람이 numbuzin 로그인을 그대로 쓴 채 fwee 쉬핑을 등록했고, 쉬핑이 numbuzin 소속·Sender numbuzin 으로 들어갔다.
 * 지금 어느 회사로 들어와 있는지 보여 주고, 다른 회사로 들어가려면 로그아웃부터 하게 한다.
 */
function AlreadyLoggedIn() {
  const navigate = useNavigate();
  const company = localStorage.getItem('verifiedClientName') || '';

  const handleSwitch = () => {
    performLogout();
    // 로그아웃 뒤 첫 화면을 새로 그린다 — 이번에는 회사 코드 입력이 나온다
    window.location.replace('/');
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="w-full max-w-sm text-center">
        <div className="flex justify-center mb-8">
          <Logo />
        </div>
        <p className="text-sm text-gray-600 mb-1">지금 이 회사로 로그인되어 있습니다</p>
        <p className="text-lg font-bold text-gray-900 mb-6" data-testid="current-company">{company || '(회사 이름 없음)'}</p>
        <div className="space-y-2">
          <Button className="w-full" onClick={() => navigate(getDefaultRoute(), { replace: true })}>
            {company ? `${company}(으)로 계속하기` : '계속하기'}
          </Button>
          <button
            type="button"
            className="w-full rounded-lg border border-gray-300 py-2.5 text-sm text-gray-700 hover:bg-gray-50"
            onClick={handleSwitch}
          >
            다른 회사로 로그인
          </button>
        </div>
        <p className="mt-4 text-xs text-gray-500">
          다른 회사 코드로 들어가면 그 회사 이름으로 캠페인·쉬핑이 등록됩니다. 회사를 바꾸려면 「다른 회사로 로그인」을 누르세요.
        </p>
      </div>
    </div>
  );
}

export default AlreadyLoggedIn;
